
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 477.5 477.5"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M407.5 69.9c-93.2-93.2-244.4-93.2-337.6 0s-93.2 244.4 0 337.6c93.2 93.2 244.4 93.2 337.6 0s93.3-244.3 0-337.6zm-17.6 320c-40 40.2-94.4 62.8-151.1 62.6C120.9 452.5 25 356.6 25 238.7 25 120.7 120.7 25 238.7 25c118 0 213.7 95.7 213.7 213.7.1 56.7-22.5 111.1-62.5 151.2z"}}),_c('path',{attrs:{"d":"M298 355.6V115.7c0-3.6-2.9-6.5-6.5-6.5s-6.5 2.9-6.5 6.5v239.9l-37.1-40-9.5 8.9 53.2 57.2 53.2-57.2-9.5-8.9-37.3 40z"}}),_c('path',{attrs:{"d":"M247 163.7c0-3.6-2.9-6.5-6.5-6.5h-107c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5h107c3.6 0 6.5-3 6.5-6.5z"}}),_c('path',{attrs:{"d":"M247 218.7c0-3.6-2.9-6.5-6.5-6.5h-71c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5h71c3.6 0 6.5-3 6.5-6.5z"}}),_c('path',{attrs:{"d":"M247 273.7c0-3.6-2.9-6.5-6.5-6.5h-41c-3.6 0-6.5 2.9-6.5 6.5s2.9 6.5 6.5 6.5h41c3.6 0 6.5-3 6.5-6.5z"}})])
          )
        }
      }
    